import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Cookies from "js-cookie";
import "../style/setup.css"

const RequireAuth = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="fullscreen-loading">
        <div className="spinner"></div>
      </div>
    )
  }

  if (!user) {
    Cookies.remove("access_token", { path: '/login' });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
